import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/BaseComponentFilledStandard.js";
import l from "../components/PfIcon.js";
const e = (t, o) => {
  const r = {
    ...t,
    ...o.attrs
  };
  return a(l, n(r, {
    icon: d
  }), null);
};
e.displayName = "BaseComponentFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
